import { useState, useEffect } from "react";

// Bootstrap components
import Container from "react-bootstrap/Container";

// Custom styles
import "../scss/pages/une.styles.scss";

// Assets
import iconLocation from "../assets/images/location-icon.png";
import iconPerson from "../assets/images/profile-icon.png";
import iconPhone from "../assets/images/phone-icon.png";
import iconEmail from "../assets/images/email-icon.png";
import uneHero from "../assets/images/une-hero-bg.jpg";

function UNE() {
  return (
    <div className="une-page">
      <section className="hero">
        <div className="container">
          <h1>
            Unidad Especializada
            <br /> de Atención a Clientes
          </h1>
        </div>
      </section>

      <section className="une-contenido">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10 col-xl-8">
              <p className="une-text text-center text-md-start">
                <strong>Para dudas, aclaraciones y reclamaciones</strong>{" "}
                deberás dirigirte a la Unidad Especializada de atención a
                usuarios, localizada en:
              </p>

              <div className="une-location-block d-flex flex-column flex-md-row align-items-center justify-content-center">
                <div className="icon-circle">
                  <img src={iconLocation} alt="Ubicación" />
                </div>
                <div className="info-text text-center text-md-start mt-3 mt-md-0 ms-md-4">
                  <strong>Av. Américas 1930. Piso 10 UP-2 Col.</strong>
                  <br />
                  Country Club. C.P. 44610. Guadalajara, Jalisco. MX.
                </div>
              </div>

              <p className="une-text text-center text-md-start">
                Además, ponemos a su disposición nuestra página de internet:
                www.afix.com.mx. En el caso de detectar impostores/posible robo
                de identidad, por favor comunicarte con el Titular de la UNE:
              </p>

              <div className="row une-contact-grid justify-content-center justify-content-md-between">
                <div className="col-12 col-md-4 contact-item d-flex flex-column flex-md-row align-items-center justify-content-center">
                  <div className="icon-circle">
                    <img src={iconPerson} alt="Titular" />
                  </div>
                  <div className="info-text text-center text-md-start mt-3 mt-md-0 ms-md-3">
                    <strong>Titular:</strong>
                    <br />
                    Iliana Álvarez
                  </div>
                </div>
                <div className="col-12 col-md-4 contact-item d-flex flex-column flex-md-row align-items-center justify-content-center">
                  <div className="icon-circle">
                    <img src={iconPhone} alt="Teléfono" />
                  </div>
                  <div className="info-text text-center text-md-start mt-3 mt-md-0 ms-md-3">
                    <strong>Teléfono:</strong> 
                    <br />
                    (33) 36 30 18 88
                  </div>
                </div>
                <div className="col-12 col-md-4 contact-item d-flex flex-column flex-md-row align-items-center justify-content-center">
                  <div className="icon-circle">
                    <img src={iconEmail} alt="Correo" />
                  </div>
                  <div className="info-text text-center text-md-start mt-3 mt-md-0 ms-md-3">
                    <strong>Correo:</strong>
                    <br />
                    unes@afix.com.mx
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default UNE;

/*     <div className="special_unit__wrapper">
      <section className="special_unit__content">
        <div className="special_unit__body">
          <h4>Unidad Especializada de Atención a Clientes</h4>
          <div className="special_unit__body_card">
            <p>
              Para dudas, aclaraciones y reclamaciones deberás dirigirte a la
              Unidad Especializada de atención a usuarios, localizada en:
            </p>
            <a
              href="https://maps.app.goo.gl/ernUY12YkWS7FZ4n6"
              target="_blank"
              rel="noreferrer"
              className="my-2 d-block"
            >
              <img src={locationIcon} alt="" />
              Av. Américas 1930. Piso 10 UP-2 Col. Country Club. C.P. 44610.
              Guadalajara, Jalisco. MX.
            </a>
            <p className="mt-2">
              Además, ponemos a su disposición nuestra página de internet:{" "}
              <a href="www.afix.com.mx">www.afix.com.mx</a>. En el caso de
              detectar impostores/posible robo de identidad, por favor
              comunicarte con el Titular de la UNE:
            </p>
            <div className="special_unit__body_card_contacts">
              <div className="special_unit__body_card_contacts_card">
                <h6>Titular:</h6>
                <div>
                  <img src={profileIcon} alt="" />
                  <p>Iliana Álvarez</p>
                </div>
                <div>
                  <img src={phoneIcon} alt="" />
                  <a href="tel:+523336301888">(33) 36 30 18 88</a>
                </div>
                <div>
                  <img src={emailIcon} alt="" />
                  <a href="mailto:ialvarez@afix.com.mx">ialvarez@afix.com.mx</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="special_unit__media">
          <img src={uneHero} alt="" />
        </div>
      </section>
    </div> */
